import React from 'react';
import DraggableComponent from './DraggableComponent';

/**
 * Panel - A true extension of DraggableComponent using HOC pattern
 * 
 * This component extends DraggableComponent with proper inheritance semantics,
 * meaning it gets ALL of DraggableComponent's functionality:
 * - Drag and resize behavior
 * - Long press selection
 * - All internal state and methods
 * 
 * But specifically does NOT handle press actions and does NOT show content
 * (text/icons) - panels are for visual elements and layout containers.
 */
const Panel = (props) => {
  // Panel-specific logic can be added here
  const handlePanelSpecificBehavior = () => {
    console.log('Panel-specific behavior triggered');
  };

  // Ensure component is treated as a panel but remove content for clean appearance
  const panelComponent = {
    ...props.component,
    type: 'panel',
    content: {
      ...props.component.content,
      primaryText: '', // Remove text
      icon: '', // Remove icon
      secondaryText: '' // Remove secondary text
    }
  };

  // Panel inherits ALL DraggableComponent functionality except press actions
  // by passing through all props but explicitly setting onPress to null
  return (
    <DraggableComponent
      {...props}
      component={panelComponent}
      onPress={null} // Panels don't handle press actions
      role="presentation"
      aria-hidden="true"
    />
  );
};

export default Panel;